import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";
import ActionTable from "../../components/table/ActionTable";
import { Button, Stack } from "@mui/material";

export default function Agenda({ history, location }) {
  const [comboEscolas, setComboEscolas] = useState([]);
  const { notification, confirm } = useContext(AppContext);
  const [exibir, setExibir] = useState(false);
  const [escola, setEscola] = useState({});
  const [filtros, setFiltros] = useState(mergeParams({ id: 0 }, location));
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState({});
  const [inserrindoEmail, setInserindoEmail] = useState(false);

  useEffect(() => {
    if (filtros.id > 0) {
      carregarEscola();
    }
    carregarComboEscolas();
  }, []);

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((res) => {
      setComboEscolas(res);
    });
  };

  const carregarEscola = (filtrosEnviar = filtros) => {
    if (!filtrosEnviar.id) return;

    setFiltros(filtrosEnviar);

    api.get("escolas/carregar", filtrosEnviar).then((res) => {
      setEscola(res);
      setExibir(true);
      setEmail({});
      carregarEmails(filtrosEnviar.id);
    });
  };

  const carregarEmails = (id) => {
    api.get("escolas/listarEmails", { escolaId: id }).then((res) => {
      setEmails(res);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      id: {
        label: "Escola",
        type: "select",
        value: filtros.id,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        emptyItem: true,
        emptyItemText: "(Selecione)",
      },
    },
    submit: {
      action: carregarEscola,
      auto: true,
    },

    urlParams: true,
    history,
    location,
  };

  const salvar = () => {
    const escolaSalvar = escola;
    escolaSalvar.id = filtros.id;
    api
      .post("escolas/salvarConfigPedidos", escolaSalvar)
      .then((res) => {
        notification("success", "Dados salvos!");
        carregarEscola();
        // setExibir(false);
        // setFiltros({ id: 0 });
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "CEP inválido");
          case 2:
            return notification("error", "Endereço inválido");
          case 3:
            return notification("error", "Número inválido");
          case 4:
            return notification("error", "Bairro inválido");
          case 5:
            return notification("error", "Município inválido");
          case 6:
            return notification("error", "UF inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const salvarDados = (campo, valor) => {
    const escolaAtualizada = { ...escola };
    escolaAtualizada[campo] = valor;

    setEscola(escolaAtualizada);
  };

  const fEntrega = {
    title: "Entregas",
    form: {
      CEP: {
        label: "CEP",
        type: "text",
        value: escola.CEP,
        space: 2,
      },
      endereco: {
        label: "Logradouro",
        type: "text",
        value: escola.endereco,
        space: 6,
      },
      numero: {
        label: "Número",
        type: "text",
        value: escola.numero,
        space: 1,
      },
      complemento: {
        label: "Complemento",
        type: "text",
        value: escola.complemento,
        space: 3,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        value: escola.bairro,
        space: 5,
      },
      municipio: {
        label: "Município",
        type: "text",
        value: escola.municipio,
        space: 5,
      },
      UF: {
        label: "UF",
        type: "text",
        value: escola.UF,
        space: 2,
      },
    },

    autoSave: salvarDados,
  };

  const fFaturamento = {
    title: "Faturamento",
    form: {
      CNPJ: {
        label: "CNPJ",
        type: "text",
        value: escola.CNPJ,
        space: 4,
      },
      diaParaPagamento: {
        label: "Dia do mês para pagamento",
        type: "text",
        value: escola.diaParaPagamento,
        space: 4,
      },
      recusarPagamentosForaPrazo: {
        label: "Recusar pagamentos fora do prazo",
        type: "check",
        value: escola.recusarPagamentosForaPrazo,
        space: 4,
      },
    },
    autoSave: salvarDados,
  };

  const fPrecos = {
    title: "Preços",
    form: {
      precoMaterialBilingue: {
        label: "Preço material Bilíngue (específico para a escola)",
        type: "number",
        value: escola.precoMaterialBilingue,
        space: 6,
      },
      precoMaterialUdt: {
        label: "Preço material Uni Dune Te (específico para a escola)",
        type: "number",
        value: escola.precoMaterialUdt,
        space: 6,
      },
      componente: {
        type: "component",
        value: (
          <Stack direction={"row"} spacing={2}>
            <Button
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              onClick={salvar}
            >
              Salvar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setExibir(false);
                setEscola({});
              }}
            >
              Fechar
            </Button>
          </Stack>
        ),
      },
    },
    autoSave: salvarDados,
  };

  const tRegistros = {
    title: "Emails para assuntos financeiros",
    onLineClick: (item) => setEmail(item),
    newItemAction: () => setInserindoEmail(true),

    columns: [
      {
        label: "Email",
        name: "email",
      },
    ],
    array: emails,
  };

  const salvarEmail = (form) => {
    if (email.escolaEmailId) {
      api
        .post("escolas/editarEmail", {
          escolaEmailId: email.escolaEmailId,
          email: form.email,
        })
        .then((res) => {
          notification("success", "Email editado!");
          setInserindoEmail(false);
          setEmail({});
          carregarEmails(filtros.id);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Email inválido");

            default:
              return notification("error", "Email inválido");
          }
        });
    } else {
      api
        .post("escolas/inserirEmail", {
          escolaId: filtros.id,
          email: form.email,
        })
        .then((res) => {
          notification("success", "Email inserido!");
          setInserindoEmail(false);
          setEmail({});
          carregarEmails(filtros.id);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Email inválido");

            default:
              return notification("error", "Email inválido");
          }
        });
    }
  };

  const excluir = () => {
    confirm({
      title: "Confirma a exclusão do email?",
      label: "Não será possível desfazer esta ação.",
      onConfirm: () => {
        api
          .delete("escolas/removerEmail", {
            escolaEmailId: email.escolaEmailId,
          })
          .then((res) => {
            notification("warning", "Email removido.");
            carregarEmails(filtros.id);
            setInserindoEmail(false);
            setEmail({});
          })
          .catch((err) => {
            notification("error", "Erro ao remover a email");
          });
      },
    });
  };

  const fEmail = {
    title: email.escolaId ? "Alterar email" : "Novo email",
    form: {
      email: {
        label: "Email",
        type: "text",
        value: email.email,
        required: true,
      },
    },

    submit: {
      label: "salvar",
      action: salvarEmail,
    },

    close: {
      label: "Cancelar",
      action: () => {
        setEmail({});
        setInserindoEmail(false);
      },
    },

    customActions: email.escolaId
      ? [
          {
            warning: true,
            label: "Excluir",
            action: excluir,
          },
        ]
      : undefined,
  };

  return (
    <div>
      <>
        <Form formData={fFiltros} />
        {exibir && (
          <div style={{ background: "white" }}>
            <Form formData={fEntrega} />
            <Form formData={fFaturamento} />
            <Form formData={fPrecos} />
          </div>
        )}
        {filtros.id > 0 && (
          <>
            {!email.escolaId && !inserrindoEmail && (
              <ActionTable structure={tRegistros} />
            )}
          </>
        )}

        {(email.escolaId || inserrindoEmail) && <Form formData={fEmail} />}
      </>
    </div>
  );
}
